import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, of } from 'rxjs';
import { LanguageService } from './services/language.service';
import { ThemeService } from './services/theme.service';
import { AuthService } from './services/auth.service';
import { Client } from './api/api-reference';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TranslateModule],
  templateUrl: './app.component.html',
  styleUrls: [
    './app.component.scss',
    './app-mobile.component.scss',
    './app-tablet.component.scss',
  ],
})
export class AppComponent implements OnInit {
  constructor(
    private languageService: LanguageService,
    private themeService: ThemeService,
    private router: Router,
    private toastr: ToastrService,
    private authService: AuthService,
    private client: Client,
    private translate: TranslateService,
    private http: HttpClient,
  ) { }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.adjustToastrPosition(event.urlAfterRedirects);
      }
    });
    if (this.authService.isLoggedIn()) {
      this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        const utility = this.authService.getUserUtility();
        if (!utility) return;
        this.http.get(`assets/i18n/utilities/${utility}/${event.lang}.json`)
          .pipe(catchError(() => of({})))
          .subscribe(overrides => this.translate.setTranslation(event.lang, overrides, true));
      });
      if (this.authService.isBpsAdmin())
        this.router.navigate(['/utilities/all']);
      else if(!localStorage.getItem('permissions')){
        this.client.getMyPermissions().subscribe({
          next: (result) => {
            localStorage.setItem('permissions', result);
            this.router.navigate(['/']);
          },
          error: (err) => {
            this.toastr.error(err)
            this.authService.logout();
          },
        });
      }
    }
  }

  adjustToastrPosition(url: string) {
    if (url.includes('/login') || this.toastr.previousToastMessage == 'Your session has expired. Please login again.') {
      this.toastr.toastrConfig.positionClass = 'toast-fixed';
    } else this.toastr.toastrConfig.positionClass = 'toast-header-fixed';
  }
}
